export function formatNumber(value: number): string {
  if (!Number.isFinite(Number(value))) return "-";
  const n = Number(value);
  if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (Math.abs(n) >= 1000) return Math.round(n).toLocaleString("en-US");
  return `${Math.round(n * 100) / 100}`;
}

export function shortDate(value: string): string {
  return String(value).slice(5);
}

export function escapeHtml(value: unknown): string {
  return String(value).replace(/[&<>"']/g, ch => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;"
  })[ch] || ch);
}
